import { render, staticRenderFns } from "./ed-subject-day-options.component.vue?vue&type=template&id=866e01b8&scoped=true&"
import script from "./ed-subject-day-options.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-day-options.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-day-options.component.scss?vue&type=style&index=0&id=866e01b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866e01b8",
  null
  
)

export default component.exports